/*! @license
 * Shaka Player
 * Copyright 2016 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

goog.provide('shaka.util.FairPlayUtils');

goog.require('shaka.drm.FairPlay');


/**
 * @summary A set of FairPlay utility functions. DEPRECATED: Please use
 *          shaka.drm.FairPlay instead.
 * @deprecated
 * @export
 */
shaka.util.FairPlayUtils = class extends shaka.drm.FairPlay {
  // DEPRECATED
};
